export default __webpack_public_path__ + "static/0096-c8851cd64c34b5404a0f54e0a8a770d3.png";